import { BatteryLifeIcon } from '@jouzen/ecom-components/icons/BatteryLifeIcon';
import { CircularOutlineCheckIcon } from '@jouzen/ecom-components/icons/CircularOutlineCheckIcon';
import { HeartbeatIcon } from '@jouzen/ecom-components/icons/HeartbeatIcon';
import { MobileConnectivityIcon } from '@jouzen/ecom-components/icons/MobileConnectivityIcon';
import { RingOutlineIcon } from '@jouzen/ecom-components/icons/RingOutlineIcon';
import { WeightIcon } from '@jouzen/ecom-components/icons/WeightIcon';
import type { RichTranslationValues } from 'next-intl';

import type { PDPTechSpecsSectionProps } from '@/app/[locale]/store/_components/HardwarePDP/PDPTechSpecsSection';
import type { PDPTechSpecsFeature } from '@/app/[locale]/store/_components/HardwarePDP/PDPTechSpecsSection/PDPTechSpecsFeatures';

type Id =
  | 'materials'
  | 'sensors'
  | 'battery'
  | 'dimensions'
  | 'compatibility'
  | 'connectivity';

export interface GetPDPTechSpecsSectionDataParams {
  featuresTValues?: { [key in Id]?: RichTranslationValues };
}

interface TechSpecsFeature extends PDPTechSpecsFeature {
  id: Id;
}
interface TechSpecsSectionProps extends PDPTechSpecsSectionProps {
  features: TechSpecsFeature[];
}

export const getPdpTechSpecsSectionData = ({
  featuresTValues,
}: GetPDPTechSpecsSectionDataParams): TechSpecsSectionProps => ({
  whatsIncludedProps: {
    imageSrc: 'product/pdp/pdp-tech-specs-or4-charger',
    localizedAlt: 'charger_set_gen_4_title',
    titleKey: 'pop_whats_included_title',
    listKey: 'ring_pdp_2025_tech_specs_included_list',
  },
  features: [
    {
      copy: { messageKey: 'ring_pdp_2025_tech_specs_sensors_list' },
      Icon: HeartbeatIcon,
      id: 'materials',
      title: 'ring_pdp_2025_tech_specs_sensors_title',
    },
    {
      copy: { messageKey: 'ring_pdp_2025_tech_specs_compatibility_list' },
      Icon: CircularOutlineCheckIcon,
      id: 'sensors',
      title: 'ring_pdp_2025_tech_specs_compatibility_title',
    },
    {
      copy: { messageKey: 'ring_pdp_2025_tech_specs_dimensions_list' },
      Icon: WeightIcon,
      id: 'dimensions',
      title: 'ring_pdp_2025_tech_specs_dimensions_title',
    },
    {
      copy: {
        messageKey: 'ring_pdp_2025_tech_specs_battery_list_v2',
        tValues: featuresTValues?.battery,
      },
      Icon: BatteryLifeIcon,
      id: 'battery',
      title: 'ring_pdp_2025_tech_specs_battery_title',
    },
    {
      copy: { messageKey: 'ring_pdp_2025_tech_specs_materials_list' },
      Icon: RingOutlineIcon,
      id: 'compatibility',
      title: 'ring_pdp_2025_tech_specs_materials_title',
    },
    {
      copy: { messageKey: 'ring_pdp_2025_tech_specs_connectivity_list' },
      Icon: MobileConnectivityIcon,
      id: 'connectivity',
      title: 'ring_pdp_2025_tech_specs_connectivity_title',
    },
  ],
  sectionTitle: 'ring_pdp_2025_tech_specs_title',
});
